export default {
  message: {
    customerNumbersAssistant: {
      date: {
        title: 'Calculate points from date X',
        warning: 'With a selected date, main business numbers cannot be moved!',
      },
      import: {
        openButton: 'Import customer numbers',
        loadingModal: 'Loading modal...',
        title: 'Import customer numbers from Excel',
        validateButton: 'Validate file',
        submitButton: 'Send to API',
        submitButtonLoading: 'Sending...',
        selectWholesalerLabel: 'Wholesaler',
        selectGroupLabel: 'Group',
        selectWholesalerPlaceholder: 'Select wholesaler',
        selectGroupPlaceholder: 'Select group (optional)',
        requirementsTitle: 'File requirements',
        fileFormatRequirement: 'Excel file only: .xlsx or .xls',
        headerRequirement: 'Header row must be: Customer number, Email (A/B columns).',
        createdLabel: 'Created',
        alreadyExistsLabel: 'Already exists',
        success: 'Excel file is valid.',
        submitSuccess: 'Customer numbers imported successfully.',
        previewTitle: 'Preview',
        summaryTitle: 'Validation summary',
        previewCount: '{count} rows, {pageSize} rows per page.',
        importableCountLabel: 'Can be imported',
        skippedCountLabel: 'Will be skipped',
        searchPlaceholder: 'Search by row, customer number, email or status',
        confirmImportTitle: 'Confirm import',
        confirmImportQuestion: 'Do you want to import available records now?',
        confirmImportButton: 'Import now',
        filters: {
          all: 'All',
          importable: 'Importable',
          skipped: 'Skipped',
        },
        row: 'Row',
        customerNumber: 'Customer number',
        email: 'Email',
        status: 'Status',
        userExists: 'User exists',
        customerNumberExists: 'Customer number exists',
        customerNumberExistsForEmail: 'Customer number exists for email',
        customerNumberOwnerEmail: 'Customer number owner email',
        conflictsFound: 'Conflicts were found. Fix them before import.',
        previousPage: 'Previous',
        nextPage: 'Next',
        pageInfo: 'Page {current} / {total}',
        progressLabel: 'Progress',
        statusLabels: {
          available_for_import: 'Available for import',
          already_linked: 'Already linked',
          customer_number_linked_to_other_user: 'Customer number linked to other user',
          user_not_found: 'User not found',
          user_not_dealer: 'User is not dealer',
          user_in_other_group: 'User is in other group',
        },
        summaryLabels: {
          total_rows: 'Total rows',
          available_for_import: 'Available for import',
          already_linked: 'Already linked',
          customer_number_linked_to_other_user: 'Linked to other user',
          user_not_found: 'User not found',
          user_not_dealer: 'User is not dealer',
          user_in_other_group: 'User in other group',
        },
        errors: {
          wholesalerRequired: 'Wholesaler is required.',
          groupRequired: 'Group is required.',
          fileRequired: 'Excel file is required.',
          emptyWorkbook: 'Excel workbook is empty.',
          invalidHeaders: 'File must contain exactly 2 columns: customer number and email.',
          emptyRows: 'File does not contain any data rows.',
          firstTwoColumnsRequired: 'Row {row}: first and second column must be filled.',
          invalidCustomerNumber: 'Invalid customer number in row {row}. Use only letters and digits.',
          invalidEmail: 'Invalid email in row {row}.',
          invalidFileType: 'Only Excel files (.xlsx, .xls) are allowed.',
          readError: 'Could not read Excel file.',
          validateFirst: 'Validate file first.',
          conflictsBeforeImport: 'Import is blocked because of validation conflicts.',
          nothingToImport: 'There are no records available for import.',
          submitFailed: 'Failed to send records to API.',
        },
      },
    },
  },
}
